import { useCallback } from 'react';
import { getLocale } from 'shared/utils/locale-util';
import { formatCurrencyAmount } from 'shared/utils/money';
import { useUserAccountDetailsContext } from 'src/contexts/UserAccountDetailsContext/UserAccountDetailsContext';
import { convertPointsToLocalCurrency, formatPointsToLocalCurrency } from 'src/utils/local-currency';

export function useUserCurrency() {
  const { accountDetails } = useUserAccountDetailsContext();
  const currencyCode = accountDetails?.currencyCode ?? 'USD';
  const usdExchangeRate = accountDetails?.usdExchangeRate ?? 1;
  const locale = getLocale(accountDetails?.countryIso ?? 'US');

  const formatPoints = useCallback(
    (points: number) => formatPointsToLocalCurrency(points, currencyCode, usdExchangeRate, locale),
    [currencyCode, locale, usdExchangeRate]
  );

  const convertPoints = useCallback(
    (points: number) => convertPointsToLocalCurrency(points, usdExchangeRate),
    [usdExchangeRate]
  );

  const formatCurrency = useCallback(
    (amount: number, amountCurrencyCode = currencyCode) => formatCurrencyAmount(amount, amountCurrencyCode, locale),
    [currencyCode, locale]
  );

  return {
    currencyCode,
    currencySymbol: accountDetails?.currencySymbol ?? '$',
    usdExchangeRate,
    formatPoints,
    formatCurrency,
    convertPoints,
  };
}
